var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],staticClass:"boxs project-box",attrs:{"target":"_blank"}},[_c('h3',[_vm._t("title"),_c('span',[_vm._t("subtitle")],2)],2),_vm._t("img")],2)}
var staticRenderFns = []

export { render, staticRenderFns }